var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect } from 'react';
import Bubble from './components/bubble';
import { useTSState } from '../TSContext';
import api from '../api/actions';
import TSPlayer from './components/TSPlayer';
// this mapping is necessary because Polly voices are not available for all languages and WE HAVE TO UPDATE IT ALSO IN THE BACKEND
const languageMapping = {
    // Chinese mappings
    zh: 'cmn-CN',
    'zh-TW': 'yue-CN',
    // Arabic mappings
    ar: 'arb',
    'fa-AF': 'fa',
    // Portuguese mappings
    'pt-PT': 'pt',
    // Norwegian mapping
    no: 'nb-NO',
    // Hebrew
    he: 'iw',
    // Auto does not map to any Polly voice
    auto: null
};
const TSInterface = ({ title }) => {
    const { state, setStateLocal } = useTSState();
    const getData = () => __awaiter(void 0, void 0, void 0, function* () {
        const LanguagesPromise = api.getAwsTranslateLanguages();
        const VoicesPromise = api.getAwsPollyVoices();
        const [Languages, Voices] = yield Promise.all([LanguagesPromise, VoicesPromise]);
        if (Languages && Voices) {
            /*
            const awsTranslateLanguagesWithVoice: Language[] = [];
      
            for (const lang of Languages) {
              const hasVoice = Voices.find(voice => {
                if (voice.LanguageCode.startsWith(lang.LanguageCode)) {
                  return true;
                } else if (languageMapping[lang.LanguageCode]) {
                  return true;
                } else {
                  console.log('No voice for language: ', lang.LanguageCode);
                }
              });
              if (hasVoice) {
                awsTranslateLanguagesWithVoice.push(lang);
              }
            }
            */
            const awsTranslateLanguagesWithVoice = [];
            const awsTranslateLanguagesWithNOVoice = [];
            // console.log('Voices: ', JSON.stringify(Voices));
            // console.log('Voices: ', Voices.length);
            // Iterate through each language in AWS Translate
            for (const lang of Languages) {
                let hasVoice = false;
                // Iterate through each voice in AWS Polly
                for (const voice of Voices) {
                    // Check if the voice's primary LanguageCode matches the current language
                    if (voice.LanguageCode.startsWith(lang.LanguageCode)) {
                        awsTranslateLanguagesWithVoice.push(lang);
                        hasVoice = true;
                        break;
                    }
                    // Check if the language matches any AdditionalLanguageCodes for the voice
                    else if (voice.AdditionalLanguageCodes &&
                        voice.AdditionalLanguageCodes.some(code => code.startsWith(lang.LanguageCode))) {
                        awsTranslateLanguagesWithVoice.push({
                            LanguageCode: voice.AdditionalLanguageCodes[0],
                            LanguageName: lang.LanguageName
                        });
                        hasVoice = true;
                        break;
                    }
                    // Check if the language matches a mapping in languageMapping
                    else if (languageMapping[lang.LanguageCode] &&
                        (voice.LanguageCode.startsWith(languageMapping[lang.LanguageCode]) ||
                            (voice.AdditionalLanguageCodes &&
                                voice.AdditionalLanguageCodes.some(code => code.startsWith(languageMapping[lang.LanguageCode]))))) {
                        awsTranslateLanguagesWithVoice.push({
                            LanguageCode: languageMapping[lang.LanguageCode],
                            LanguageName: lang.LanguageName
                        });
                        hasVoice = true;
                        break;
                    }
                }
                // If no matching voice is found, add the language to the "no voice" list
                if (!hasVoice) {
                    awsTranslateLanguagesWithNOVoice.push(lang);
                }
            }
            // console.log('total languages with voice: ', awsTranslateLanguagesWithVoice.length);
            // console.log(JSON.stringify(awsTranslateLanguagesWithVoice));
            // console.log('total languages with NO voice: ', awsTranslateLanguagesWithNOVoice.length);
            // console.log(JSON.stringify(awsTranslateLanguagesWithNOVoice));
            const langsFinal = [...awsTranslateLanguagesWithVoice, ...awsTranslateLanguagesWithNOVoice];
            setStateLocal({
                languageList: langsFinal,
                languageListWithVoice: awsTranslateLanguagesWithVoice,
                voiceList: Voices
            });
        }
    });
    useEffect(() => {
        if (state.languageList.length === 0)
            getData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (state.hideBubble)
        return null;
    if (state.currentScreen === 'bubble') {
        return React.createElement(Bubble, null);
    }
    if (state.currentScreen === 'player') {
        return React.createElement(TSPlayer, null);
    }
    return null;
};
export default TSInterface;
